import CodeBlockLowlight from '@tiptap/extension-code-block-lowlight';
import Heading from '@tiptap/extension-heading';
import Link from '@tiptap/extension-link';
import TaskItem from '@tiptap/extension-task-item';
import TaskList from '@tiptap/extension-task-list';
import Typography from '@tiptap/extension-typography';
import { ReactNodeViewRenderer } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import { common, createLowlight } from 'lowlight';
import CodeBlockComponent from '../components/CodeBlockComponent';
import { BlockFileCard } from '../nodes/BlockFileCard';
import { InlineFileCard } from '../nodes/InlineFileCard';
import { UserMentionNode } from '../nodes/UserMention';
import Collapsible, {
  CollapsibleContent,
  CollapsibleSummary,
} from './Collapsible';
import CustomFileHandler from './CustomFileHandler';
import ImageResize from './ImageResize';
import { setOnSelectAICallback } from './suggestion';

const lowlight = createLowlight(common);

const extensions = [
  StarterKit.configure({
    codeBlock: false,
    heading: false,
    link: false,
  }),
  Collapsible.configure({
    persist: true,
    HTMLAttributes: {
      class: 'collapsible',
    },
  }),
  CollapsibleSummary,
  CollapsibleContent,
  Link.configure({
    openOnClick: false,
    autolink: true,
    defaultProtocol: 'https',
  }),
  ImageResize.configure({
    inline: true,
  }),
  Heading.configure({
    levels: [1, 2, 3],
  }),
  Typography,
  CodeBlockLowlight.extend({
    addNodeView() {
      return ReactNodeViewRenderer(CodeBlockComponent);
    },
  }).configure({
    lowlight,
  }),
  TaskList,
  TaskItem,
  CustomFileHandler,
  InlineFileCard,
  BlockFileCard,
  UserMentionNode,
];

export { setOnSelectAICallback };
export default extensions;
